var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WText',{attrs:{"tag":_vm.tag,"align":_vm.align,"color":_vm.color,"underline":_vm.underline,"italic":_vm.italic,"size":_vm.size,"weight":_vm.weight}},[_vm._v(" "+_vm._s(_vm.displayNumber)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }